var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6.42871C2.89543 6.42871 2 7.32414 2 8.42871V10.0835C2 10.9667 2.57934 11.7453 3.42531 11.9991L10.8506 14.2267C11.6004 14.4516 12.3996 14.4516 13.1494 14.2267L20.5747 11.9991C21.4207 11.7453 22 10.9667 22 10.0835V8.42871C22 7.32414 21.1046 6.42871 20 6.42871H4ZM12.75 9.85742C12.75 9.44321 12.4142 9.10742 12 9.10742C11.5858 9.10742 11.25 9.44321 11.25 9.85742V11.5717C11.25 11.9859 11.5858 12.3217 12 12.3217C12.4142 12.3217 12.75 11.9859 12.75 11.5717V9.85742Z",
    fill: "#FFCACA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.0835 13.0125V16.9999C2.0835 19.6232 4.21015 21.7499 6.8335 21.7499H17.1668C19.7902 21.7499 21.9168 19.6232 21.9168 16.9999V13.0123C21.6401 13.1934 21.3344 13.3373 21.0057 13.4359L13.5804 15.6635C12.5495 15.9728 11.4505 15.9728 10.4196 15.6635L2.99429 13.4359C2.66571 13.3374 2.36012 13.1935 2.0835 13.0125ZM2.14511 10.8318L12.0002 12.5001L21.8549 10.8318C21.6323 11.383 21.1694 11.8208 20.5747 11.9992L13.1494 14.2268C12.3996 14.4517 11.6004 14.4517 10.8506 14.2268L3.42531 11.9992C2.83058 11.8208 2.36763 11.383 2.14511 10.8318ZM11.9995 13.9999L12.0001 14L12 14.0001L11.9995 13.9999Z",
    fill: "#FFCACA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3334 6.42855V5C15.3334 3.89543 14.438 3 13.3334 3H10.6667C9.56218 3 8.66675 3.89543 8.66675 5L8.66675 6.42855",
    stroke: "#FFCACA",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase);
export default __webpack_public_path__ + "static/media/Case.4ca1851b63cb3cf1ce6053eb64527d02.svg";
export { ForwardRef as ReactComponent };